import VrrCollapse from './VrrCollapse';

export default VrrCollapse;
